module.exports = __webpack_public_path__ + "img/shop.b69f8f54.svg";